// extracted by mini-css-extract-plugin
export default {"exerciseCard":"ExerciseCard_exerciseCard__rEIpc"};